import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { X, Cookie } from 'lucide-react';
import { Link } from 'react-router-dom';

const CookieBanner = () => {
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        // Check if user has already accepted cookies
        const cookiesAccepted = localStorage.getItem('colectarium_cookies_accepted');
        if (!cookiesAccepted) {
            // Show banner after a small delay
            const timer = setTimeout(() => setShowBanner(true), 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('colectarium_cookies_accepted', 'true');
        setShowBanner(false);
    };

    const handleDecline = () => {
        localStorage.setItem('colectarium_cookies_accepted', 'declined');
        setShowBanner(false);
    };

    if (!showBanner) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-100 p-4 animate-in slide-in-from-bottom duration-300">
            <div className="container mx-auto max-w-4xl">
                <div className="bg-white rounded-2xl shadow-lg border p-4 md:p-6 flex flex-col md:flex-row items-start md:items-center gap-4">
                    <div className="flex items-start gap-3 flex-1">
                        <Cookie className="w-6 h-6 text-primary shrink-0 mt-1" />
                        <div>
                            <p className="font-semibold text-foreground mb-1">
                                Folosim cookie-uri 🍪
                            </p>
                            <p className="text-sm text-muted-foreground">
                                Acest site folosește cookie-uri pentru a-ți oferi o experiență mai bună. 
                                Prin continuarea navigării, ești de acord cu{' '}
                                <Link to="/cookie-policy" className="text-primary hover:underline">
                                    Politica de Cookie-uri
                                </Link>
                                .
                            </p>
                        </div>
                    </div>
                    <div className="flex items-center gap-2 shrink-0 w-full md:w-auto">
                        <Button
                            variant="outline"
                            size="sm"
                            onClick={handleDecline}
                            className="rounded-full flex-1 md:flex-none"
                        >
                            Refuz
                        </Button>
                        <Button
                            size="sm"
                            onClick={handleAccept}
                            className="rounded-full bg-primary hover:bg-primary/90 flex-1 md:flex-none"
                        >
                            Accept
                        </Button>
                    </div>
                    <button
                        onClick={handleDecline}
                        className="absolute top-2 right-2 md:hidden p-1 rounded-full hover:bg-gray-100"
                    >
                        <X className="w-4 h-4 text-muted-foreground" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieBanner;
